import React, { Fragment, useEffect, useState } from "react";
import {  Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Nav, NavItem, NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import "./Support.css";
import { useLocation } from "react-router";
import CreateRequest from "./CreateRequest";
import { failed, success } from "../../utils/Tostify";
import { getAllRequests } from "../../api/Applications";
import { useDispatch, useSelector } from "react-redux";
import CustomPagination from "../../components/Pagination/CustomPagination";
import Loader from "../../components/Loader/Loader";
import MultiSelectCheckbox from "../../components/InputFields/MultiSelectWithCheckboc";
import { columnFilterSupportOptions, columnSupportOptions } from "../applications/Constant";
import { ITEMS_PER_PAGE } from "../../utils/constants";
import CreatePlatformRequest from "./CreatePlatformSupportRequest";
import DynamicFilterDropdown from "../../components/Filters/Filter";
import {  applyFiltersSupport } from "../../utils/common";
import { decryptData } from "../../utils/helper";
import { getStaffs } from "../../api/User";
import { deleteFilter } from "../../api/filters";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";
import { statusOptions } from "../patient/Constant";

function Support() {
    let user = useSelector(state => state.userReducer.user);
    let token = useSelector(state=> state.userReducer.token);
    const location = useLocation();
    const userRole = localStorage.getItem("userRole");
    const clinicId = localStorage.getItem("currentHospitalId");
    const organizationId = localStorage.getItem("currentOrgId");
    const [createRequestOpen, setRequestOpen] = useState(location.state?.createRequest || false);
    const [supportRequestsList, setSupportRequestsList] = useState([]);
    const [requestCounts, setRequestCounts] = useState({});
    const [filteredSupportRequestList, setFilteredSupportRequestList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // const [listFilter, setListFilter] = useState("all");
    const [listFilter, setListFilter] = useState(userRole === "Platform" ? "assigned-me" : "all");
    const [searchKey, setSearchKey] = useState("");
    const [assignToList, setAssignToList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedFilter, setSelectedFilter] = useState([]);
    const [dropdownState, setDropdownState] = useState({});
    const { getConfirmation } = useConfirmDialog();
    const [selectedCustomFilterId, setSelectedCustomFilterId] = useState(null);

    const dispatch = useDispatch();
    const [sortBy, setSortBy] = useState({
        column: "",
        desc: false
    });
    const [selectedOption, setSelectedOption] = useState(
        columnSupportOptions.map((option) => option.value)
    );

    const togglefour = (filterId) => {
        setDropdownState((prevState) => ({
          ...prevState,
          [filterId]: !prevState[filterId]
        }));
    };

    const getSupportRequestList = async () => {
        let res;
        try {
            setIsLoading(true);
            // setSearch(searchKey);

            res = await getAllRequests({listFilter, token, userId: user._id, userRole:userRole, clinicId: clinicId, organizationId:organizationId});
            const responseData = decryptData(res.data);
            if (res?.status === "SUCCESS") {
            setSupportRequestsList(responseData);
            setFilteredSupportRequestList(responseData?.list);
            setRequestCounts(responseData?.filterCounts);
            setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message || "Something went wrong while fetching support requests");
            setIsLoading(false);
        }
    };

    const getStaffList = async (page, limit, searchKey = "") => {
        let res;
        try {
            res = await getStaffs({ dispatch, token, page, limit, searchKey,dataLimit: "all" });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                const dropdownData = responseData?.items?.map((staff) => ({
                    label: `${staff.firstName} ${staff.lastName}`,
                    value: staff._id,
                    roleDetails : staff.roleDetails
                    }));
                setAssignToList(dropdownData);
            }
        } catch (error) {
          failed(res?.message);
        }
      };

      useEffect(() => {
        getStaffList();
      }, []);

    const filterMessages = () => {
        if (!searchKey.trim()) return filteredSupportRequestList;

        return filteredSupportRequestList?.filter((support) =>
            support?.title?.toLowerCase().includes(searchKey.toLowerCase()) ||
            support?.description?.toLowerCase().includes(searchKey.toLowerCase()) ||
            support?.ticketId?.toLowerCase().includes(searchKey.toLowerCase())
        );
    };

    const searchedRequest = filterMessages();
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedSupportList = searchedRequest?.slice(startIndex, endIndex);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchKey, filteredSupportRequestList]);

    const handlePagination = (page) => {
        setCurrentPage(page);
    };

    const handleCreateRequest = () => {
        setRequestOpen(true);
    };
    const handleCancel = () => {
        setRequestOpen(false);
    };

    useEffect(() => {
        if(listFilter !== ""){
            getSupportRequestList();
        }
    }, [listFilter]);

    const handleFilter = (status) => {
        setListFilter(status);
        setSelectedCustomFilterId(null); // Clear custom filter selection when standard filter is clicked
    };

    const handleSort = (column) => {
        setSortBy((prevSortBy) => {
            const newSortBy = {
                column,
                desc: column === prevSortBy.column ? !prevSortBy.desc : false
            };
            const sortDirection = newSortBy.desc ? 1 : -1;

            // Now sort the list based on the newSortBy values
            const sortedRequest = [...filteredSupportRequestList].sort((a, b) => {
                if (column === "ticketId") {
                    // Extract numeric part from "CA-000003" -> 3
                    const numA = parseInt(a.ticketId.split("-")[1], 10);
                    const numB = parseInt(b.ticketId.split("-")[1], 10);
                    return (numA - numB) * sortDirection;
                } else if (column === "title") {
                    return a.title?.toLowerCase().localeCompare(b.title?.toLowerCase()) * sortDirection;
                }
                return 0;
            });

            setFilteredSupportRequestList(sortedRequest);
            return newSortBy;
        });
    };

    const handleColumn = (event) => {
        setSelectedOption(event.target.value);
    };

    const applySupportFilters = (filters) => {
        let result = supportRequestsList?.allRequest || []; // 🔥 apply on allRequest now
        const filtered = applyFiltersSupport(filters, result, "Support");
        setFilteredSupportRequestList(filtered);
    };

    const handleFilterSelect = (filter) => {
        const newFilters = filter.filters;
        applySupportFilters(newFilters);
        setSelectedFilter(newFilters);
        setSelectedCustomFilterId(filter._id); // Set selected custom filter ID
    };

    const  handleFilterDelete  = async(id) =>{
        const confirmed = await getConfirmation({
          title: "Attention!",
          entryName: "",
          actionBtnTitle: "Yes",
          message: `Are you sure you want to delete Filter?`
        });
        if (confirmed) {
            let res;
            try {
                const values = {filterId: id};
                setIsLoading(true);
                res = await deleteFilter({values, dispatch, token});
                if (res?.status === "SUCCESS") {
                    setIsLoading(false);
                    await getSupportRequestList();
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
          }
      };

    const getCustomFilterCount = (filter) => {
        if (!filter?.filters || !Array.isArray(supportRequestsList?.allRequest)) {
          return 0;
        }
        const filteredRequests = supportRequestsList.allRequest.filter((request) => {
          return filter.filters.every((f) => {
            const fieldValue = getNestedValue(request, f.field);
            if (f.operator === "Is") {
              return fieldValue == f.value;
            }
            else if (f.operator === "Contains") {
              return typeof fieldValue === "string" && fieldValue.includes(f.value);
            }
            else {
              return true;
            }
          });
        });
        return filteredRequests.length;
      };

      // Helper function to safely get nested fields like "createdBy"
    const getNestedValue = (obj, path) => {
        if (!obj) return undefined;
        if (path === "createdBy") {
            return obj.createdBy?._id || obj.createdBy; // smart fallback
        }
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };

    return (
        <Fragment>
        {isLoading ? <Loader /> : null}
        <div className="support_block_container">
        {!createRequestOpen &&
            <div className="d-flex justify-content-between align-items-center main-header-block gap-3">
                <div className="left_header">
                    <h2 className="home-title">Support</h2>
                </div>
                <div className="right_header_block d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <button className="application_add" onClick={handleCreateRequest}>Create Request</button>
                    <div className="right_header d-flex align-items-center">
                        <div className="drop_block">
                        <MultiSelectCheckbox
                            options={columnSupportOptions}
                            selectedOptions={selectedOption}
                            onChange={handleColumn}
                            placeholder="All Columns"
                            sx={{ width: '180px' }}
                        />
                        </div>
                        <DynamicFilterDropdown onFilterChange={applySupportFilters} type="Support" selectedFilters={selectedFilter} columnOptions={columnFilterSupportOptions} refetch={getSupportRequestList} staffList={assignToList}/>
                        <Form className="form_block" onSubmit={(e) => e.preventDefault()}>
                            <FormGroup className="spacing_three">
                                <Input
                                    id="exampleSearch"
                                    name="search"
                                    placeholder="Search for a Support Request"
                                    type="search"
                                    value={searchKey}
                                    onChange={(e) => {
                                        setSearchKey(e.target.value);
                                        setCurrentPage(1);  // Reset to page 1 when search term changes
                                    }}
                                />
                                {/* <i className="fa fa-search"></i> */}
                            </FormGroup>
                        </Form>
                    </div>
                </div>
            </div>}
            {/* <div className="horizontal_divider"></div> */}
            <div className="row m-0">
                {!createRequestOpen &&
                <div className="col-lg-2 col-md-12 nav_side">
                    <Nav vertical className="gap-2">
                    <NavItem className={listFilter === "assigned-me" && !selectedCustomFilterId ? 'active' : ''}>
                        {userRole === "Platform" && (
                            <NavLink
                            href="#"
                            onClick={() => handleFilter("assigned-me")}
                            className="d-flex justify-content-between dashbord_nav mb-2"
                        >
                            Assigned to Me
                            <span>{requestCounts?.assignedToMe ? requestCounts?.assignedToMe : 0}</span>
                        </NavLink>
                        )}
                        </NavItem>
                        <NavItem className={listFilter === "all" && !selectedCustomFilterId ? 'active' : ''}>
                        <NavLink
                            href="#"
                            onClick={() => handleFilter("all")}
                            className="d-flex justify-content-between dashbord_nav mb-2"
                        >
                            All Requests
                            <span>{requestCounts?.all ? requestCounts?.all : 0}</span>
                        </NavLink>
                        </NavItem>
                        <NavItem className={listFilter === "created-by-me" && !selectedCustomFilterId ? 'active' : ''}>
                        <NavLink
                            href="#"
                            onClick={() => handleFilter("created-by-me")}
                            className="d-flex justify-content-between dashbord_nav mb-2"
                        >
                                Created by Me
                                <span>{requestCounts?.createdBy ? requestCounts?.createdBy : 0}</span>
                                </NavLink>
                        </NavItem>
                        <NavItem className={listFilter === "Open" && !selectedCustomFilterId ? 'active' : ''}>
                            <NavLink
                                href="#"
                                onClick={() => handleFilter("Open")}
                                className="d-flex justify-content-between dashbord_nav mb-2"
                            >
                                Open
                            <span>{requestCounts?.Open ? requestCounts?.Open : 0}</span>
                            </NavLink>
                        </NavItem>
                        <NavItem className={listFilter === "Completed" && !selectedCustomFilterId ? 'active' : ''}>
                        <NavLink
                            href="#"
                            onClick={() => handleFilter("Completed")}
                            className="d-flex justify-content-between dashbord_nav mb-2"
                        >
                            Completed
                            <span>{requestCounts?.Completed ? requestCounts?.Completed : 0}</span>
                        </NavLink>
                        </NavItem>
                        {supportRequestsList?.filterList?.length > 0 && <h4 className="my_request">Custom Filters</h4>}
                        {supportRequestsList?.filterList?.length > 0 && supportRequestsList?.filterList?.map((filter) => (
                            <>
                        <NavItem
                            // className="d-flex justify-content-between align-items-center"
                              className={`d-flex justify-content-between align-items-center ${selectedCustomFilterId === filter._id ? 'active' : ''}`}
                            key={filter?._id}>
                            <NavLink href="#" className="d-flex justify-content-between dashbord_nav mb-2" key={filter?._id} onClick={() => {handleFilterSelect(filter);}}>
                            {filter.title} ({getCustomFilterCount(filter)})
                            </NavLink>
                            <Dropdown
                                isOpen={dropdownState[filter._id] || false}
                                toggle={() => togglefour(filter._id)}
                                >
                                <DropdownToggle caret size="xl" className="filter_block_blk">
                                    <i className="fa fa-ellipsis-v"></i>
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem
                                    className="d-flex gap-2 drop_block_content align-items-center"
                                    onClick={() => handleFilterDelete(filter._id)}
                                    >
                                    Delete View
                                    </DropdownItem>
                                </DropdownMenu>
                                </Dropdown>
                        </NavItem>
                        </>
                        ))
                        }
                    </Nav>
                </div>}
                <div className="col-lg-10 col-md-12 table_space table_listing_color">
                    {createRequestOpen ? (
                    userRole === "Platform" ? (
                        <CreatePlatformRequest onCancel={handleCancel} getSupportRequestList={getSupportRequestList} />
                    ) : (
                        <CreateRequest onCancel={handleCancel} getSupportRequestList={getSupportRequestList} />
                    )
                    ) : (
                    <div>
                        <div className="table-responsive suppotrt_table">
                        <table>
                            <thead>
                                <tr className="header_table">
                                    {selectedOption.length !== 0 && selectedOption.includes("ticketId") && (
                                        <th>
                                        Ticket ID
                                        <i
                                            onClick={() => handleSort("ticketId")}
                                            className='fas fa-sort'>
                                        </i>
                                    </th>
                                    )}
                                    {selectedOption.length !== 0 && selectedOption.includes("title") && (
                                        <th>
                                        Support Title
                                        <i
                                            onClick={() => handleSort("title")}
                                            className='fas fa-sort'>
                                        </i>
                                    </th>
                                    )}
                                    {selectedOption.length !== 0 && selectedOption.includes("requestType") && (
                                        <th> Request Type </th>
                                    )}
                                    {userRole === "Platform" && selectedOption.length !== 0 && selectedOption.includes("category") && (
                                    <th> Category </th>
                                    )}
                                    {userRole === "Platform" && selectedOption.length !== 0 && selectedOption.includes("priority") && (
                                    <th> Priority </th>
                                    )}
                                    {userRole === "Platform" && selectedOption.length !== 0 && selectedOption.includes("assignedTo") && (
                                    <th> Assigned To </th>
                                    )}
                                    {selectedOption.length !== 0 && selectedOption.includes("status") && (
                                        <th>Status</th>
                                    )}
                                    {userRole === "Platform" && selectedOption.length !== 0 && selectedOption.includes("resolution") && (
                                        <th>Resolution</th>
                                    )}
                                    {selectedOption.length !== 0 && selectedOption.includes("createdAt") && (
                                        <th>Create Date</th>
                                    )}
                                    {selectedOption.length !== 0 && selectedOption.includes("createdBy") && (
                                        <th>Created By</th>
                                    )}
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td colSpan={9} height={5} className="bg_light"></td>
                                </tr>

                                {paginatedSupportList?.length > 0 ? (
                                paginatedSupportList?.map((request) => (
                                    <tr key={request._id} className="first_block">

                                    {selectedOption.length !== 0 && selectedOption.includes("ticketId") && (
                                    // <td>{request?.ticketId}</td>
                                        <td><Link to={"/app/support/supportDetails"} state={{ supportData: request }}>{request.ticketId}</Link></td>
                                    )}
                                    {selectedOption.length !== 0 && selectedOption.includes("title") && (
                                        <td>{request?.title?.length > 50 ? request.title.substring(0, 40) + "..." : request?.title}</td>
                                    )}
                                    {selectedOption.length !== 0 && selectedOption.includes("requestType") && (
                                        <td>{request?.requestType}</td>
                                    )}
                                    {userRole === "Platform" && selectedOption.length !== 0 && selectedOption.includes("category") && (
                                        <td>{request?.category}</td>
                                    )}
                                    {userRole === "Platform" && selectedOption.length !== 0 && selectedOption.includes("priority") && (
                                        <td>{request.priority || "N/A"}</td>
                                    )}
                                    {userRole === "Platform" && selectedOption.length !== 0 && selectedOption.includes("assignedTo") && (
                                        <td>{request.assignedTo?.firstName ? `${request.assignedTo?.firstName} ${request.assignedTo?.lastName}` : "Unassigned"}</td>
                                    )}
                                    {selectedOption.length !== 0 && selectedOption.includes("status") && (
                                        <td>{statusOptions.find(option => option.value === request?.status)?.label || '-'}</td>
                                    )}
                                    {userRole === "Platform" && selectedOption.length !== 0 && selectedOption.includes("resolution") && (
                                        <td>{request?.resolution || "N/A"}</td>
                                    )}
                                    {selectedOption.length !== 0 && selectedOption.includes("createdAt") && (
                                        <td>{new Date(request.createdAt).toLocaleDateString()}</td>
                                    )}
                                    {selectedOption.length !== 0 && selectedOption.includes("createdBy") && (
                                        <td>{`${request.createdBy?.firstName} ${request.createdBy?.lastName}`}</td>
                                    )}
                                    <td></td>
                                    <td className="check_in p-2">
                                        <Link to={"/app/support/supportDetails"} state={{ supportData: request }} className="d-flex flex-column gap-1 align-items-center"><i className="fa fa-external-link"></i>View Details</Link>
                                    </td>
                                    </tr>
                                ))
                                ) : (
                                <tr>
                                    <td colSpan={8} className="text-center p-3">No support requests found</td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                        <div className='d-flex justify-content-center'>
                        <CustomPagination
                            totalPages={Math.ceil(searchedRequest?.length / ITEMS_PER_PAGE)}
                            totalRows={searchedRequest?.length}
                            rowsPerPage={ITEMS_PER_PAGE}
                            page={currentPage}
                            handlePage={handlePagination}
                        />
                        </div>
                    </div>
                    )}
                </div>
            </div>
        </div >
        </Fragment>
    );
}

export default Support;
